import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

// Lowercase brand wordmark with the gradient "ync" tail.
// useTranslations is RSC-safe, so this works in server and client components.
export function Wordmark({ className }: { className?: string }) {
  const t = useTranslations("common.app");
  return (
    <span
      className={cn(
        "font-heading font-extrabold tracking-tight text-foreground",
        className,
      )}
    >
      {t("brandPrefix")}
      <span className="bg-linear-to-r from-primary to-secondary bg-clip-text text-transparent">
        {t("brandSuffix")}
      </span>
    </span>
  );
}
